import { forEach } from "lodash";

import setGroupingWithDefaultConstraints from "./setGroupingWithDefaultConstraints";

const setGroupingsWithDefaultConstraints = ({
  groupings,
  allocationProjectLookup,
  columns,
}) => {
  forEach(groupings, (grouping) => {
    setGroupingsWithDefaultConstraints({
      groupings: grouping.childGroupings,
      allocationProjectLookup,
      columns,
    });

    setGroupingWithDefaultConstraints({
      grouping,
      allocationProjectLookup,
      columns,
    });
  });
};

export default setGroupingsWithDefaultConstraints;
